import {
  PublishParams,
  ProductFields,
  ProductListParams,
} from "../../view/Modules/Products/ProductDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const ProductServices = {
  getProducts: (params: ProductListParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.PRODUCTS, {
        params,
        headers: { disableLoader: true },
      });
    }
    return AxiosInstance.get(ContentApiRoutes.PRODUCTS, { params });
  },
  getProductsToImport: (params: ProductListParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.PRODUCTS_TO_IMPORT, {
        params,
        headers: { disableLoader: true },
      });
    }
    return AxiosInstance.get(ContentApiRoutes.PRODUCTS_TO_IMPORT, { params });
  },
  getCompanyProducts: (params: ProductListParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.COMPANY_PRODUCTS, {
        params,
        headers: { disableLoader: true },
      });
    }
    return AxiosInstance.get(ContentApiRoutes.COMPANY_PRODUCTS, { params });
  },
  importProductsForCompany: (data: any) => {
    return AxiosInstance.post(
      ContentApiRoutes.IMPORT_PRODUCTS_FOR_COMPANY,
      data
    );
  },
  getStoreProductsToImport: (params: ProductListParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.STORE_PRODUCTS_TO_IMPORT, {
        params,
        headers: { disableLoader: true },
      });
    }
    return AxiosInstance.get(ContentApiRoutes.PRODUCTS_TO_IMPORT, { params });
  },
  getStoreProducts: (params: ProductListParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.STORE_PRODUCTS, {
        params,
        headers: { disableLoader: true },
      });
    }
    return AxiosInstance.get(ContentApiRoutes.STORE_PRODUCTS, { params });
  },
  importProductsForStore: (data: any) => {
    return AxiosInstance.post(ContentApiRoutes.IMPORT_PRODUCTS_FOR_STORE, data);
  },
  getProductTypes: () => AxiosInstance.get(ContentApiRoutes.PRODUCT_TYPES),
  getProductCategories: (productType: number) =>
    AxiosInstance.get(
      ContentApiRoutes.PRODUCT_CATEGORIES + "?product_type=" + productType
    ),
  getProductCategoriesByStore: (storeId: number) =>
    AxiosInstance.get(
      ContentApiRoutes.PRODUCT_CATEGORIES + "?store=" + storeId
    ),
  getProductTypeFields: (productType: number) =>
    AxiosInstance.get(
      ContentApiRoutes.PRODUCT_FIELDS + `${"?product_type=" + productType}`
    ),
  exportProducts: (params: ProductListParams) => {
    return AxiosInstance.get(ContentApiRoutes.EXPORT_PRODUCTS, {
      params,
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Products-export.xls");
      document.body.appendChild(link);
      link.click();
    });
  },
  createProduct: (data: ProductFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_PRODUCT, data),
  updateProduct: (id: number, data: ProductFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_PRODUCT.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  publishProduct: (id: number, data: PublishParams) =>
    AxiosInstance.put(
      ContentApiRoutes.PUBLISH_PRODUCT.replace(":id", id.toString()),
      data
    ),

  publishBulkProduct: (ids: number[], data: PublishParams) =>
    AxiosInstance.put(ContentApiRoutes.PUBLISH_BULK_PRODUCT, {
      ...data,
      ...{ ids: ids.toString() },
    }),

  deleteProduct: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_PRODUCT.replace(":id", id.toString())
    ),
  deleteBulkProduct: (ids: number[]) => {
    let idl = { ids: ids.toString() };
    return AxiosInstance.put(ContentApiRoutes.DELETE_BULK_PRODUCT, idl);
  },
  deleteCompanyBulkProduct: (ids: number[]) => {
    let idl = { ids: ids.toString() };
    return AxiosInstance.put(ContentApiRoutes.DELETE_COMPANY_BULK_PRODUCT, idl);
  },
  deleteStoreBulkProduct: (ids: number[]) => {
    let idl = { ids: ids.toString() };
    return AxiosInstance.put(ContentApiRoutes.DELETE_STORE_BULK_PRODUCT, idl);
  },
  viewProduct: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_PRODUCT.replace(":id", id.toString())
    );
  },
  viewCompanyProduct: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_COMPANY_PRODUCT.replace(":id", id.toString())
    );
  },
  viewStoreProduct: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_STORE_PRODUCT.replace(":id", id.toString())
    );
  },

  uploadImage: (id: any, file: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPLOAD_PRODUCT_IMAGE.replace(":id", id.toString()) +
        "?_method=PUT",
      file
    ),

  deleteProductImage: (id: number) =>
    AxiosInstance.post(
      ContentApiRoutes.DELETE_PRODUCT_IMAGE.replace(":id", id.toString()) +
        "?_method=PUT"
    ),
};
